module.exports = __webpack_public_path__ + "static/media/calendar.4f97fc29.svg";